/** 浏览器 Cookie 读写（首屏/组件内偏好类数据，体量应极小） */

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null
  const encoded = encodeURIComponent(name)
  const re = new RegExp(`(?:^|; )${encoded.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`)
  const m = document.cookie.match(re)
  return m ? decodeURIComponent(m[1]) : null
}

export function setCookie(
  name: string,
  value: string,
  options?: {
    maxAgeSeconds?: number
    path?: string
    sameSite?: 'Lax' | 'Strict'
    secure?: boolean
    domain?: string
  }
) {
  if (typeof document === 'undefined') return
  const path = options?.path ?? '/'
  const maxAge = options?.maxAgeSeconds ?? 60 * 60 * 24 * 400
  const sameSite = options?.sameSite ?? 'Lax'
  const useSecure =
    options?.secure ?? (typeof location !== 'undefined' && location.protocol === 'https:')

  let chunk = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}; max-age=${maxAge}; SameSite=${sameSite}`
  if (options?.domain) chunk += `; Domain=${options.domain}`
  if (useSecure) chunk += '; Secure'
  document.cookie = chunk
}
